import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import { FooterCopyrightDataElementType } from '@/components/sections/builder/elements/footer/footer-copyright/types';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import InputTab from '@/components/sections/builder/settings/input-tab';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { useBuilderStore } from '@/stores/builder';
import React from 'react';
import { shallow } from 'zustand/shallow';

const ElementSetting = ({ element }: ElementProps) => {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
    }),
    shallow
  );
  const data = element.data as FooterCopyrightDataElementType;
  return (
    <div>
      <div className='mb-4'>
        <h3 className='mb-2 text-base font-bold'>Text</h3>
        <TextEditorMinimal
          onChange={(value) =>
            builder.setElementData(element.id, {
              text: value,
            })
          }
          value={data.text}
          placeholder='Label'
          className='mb-2 w-full max-w-64'
          output='html'
          editorProps={{
            attributes: {
              class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
            },
          }}
          editable
        />
        <div className='mb-2'>Text Alignment</div>
        <InputTab
          defaultValue={data.textAlignment}
          options={[
            { label: 'Left', value: 'left' },
            { label: 'Center', value: 'center' },
            { label: 'Right', value: 'right' },
          ]}
          onChange={(val) =>
            builder.setElementData(element.id, {
              textAlignment: val,
            })
          }
        />
      </div>
      <div className='mb-4'>
        <h3 className='mb-2 text-base font-bold'>Color scheme</h3>
        <SchemeSetting
          value={data.colorSchemeFooterCopyright}
          onChange={(theme) => {
            builder.setElementData(element.id, {
              colorSchemeFooterCopyright: theme,
            });
          }}
        />
      </div>
      <div className='mb-4'>
        <h3 className='text-base font-bold'>Section Padding</h3>
        <InputSlider
          label='Top padding'
          value={data.topPadding}
          max={100}
          onChange={(val) =>
            builder.setElementData(element.id, {
              topPadding: val,
            })
          }
        />
        <InputSlider
          label='Bottom padding'
          max={100}
          value={data.bottomPadding}
          onChange={(val) =>
            builder.setElementData(element.id, {
              bottomPadding: val,
            })
          }
        />
      </div>
    </div>
  );
};

export default ElementSetting;
